import { __rest } from 'tslib';
import React from 'react';
import VideoControlIconButton from '../VideoControlIconButton/VideoControlIconButton.mjs';
import StyledVideoContainer from './VideoContainer.styles.mjs';
import { useTheme } from 'styled-components';

const VideoContainer = (_a) => {
    var { iconType, skipStep, onClick, onDoubleClick, showOverlayIcon = true, children } = _a, styleProps = __rest(_a, ["iconType", "skipStep", "onClick", "onDoubleClick", "showOverlayIcon", "children"]);
    const theme = useTheme();
    const getSkipStep = (iconType) => {
        switch (iconType) {
            case 'forward': {
                return `${skipStep}s`;
            }
            case 'backward': {
                return `${skipStep}s`;
            }
            default:
                return '';
        }
    };
    return (React.createElement(StyledVideoContainer, Object.assign({ iconType: iconType, onClick: onClick, onDoubleClick: onDoubleClick, showOverlayIcon: showOverlayIcon }, styleProps), children !== null && children !== void 0 ? children : (React.createElement(VideoControlIconButton, { iconType: iconType, color: theme.colors.white, variant: "secondary", onClick: onClick, className: `${iconType}-button-video-control` }, getSkipStep(iconType)))));
};

export { VideoContainer as default };
//# sourceMappingURL=VideoContainer.mjs.map
